import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Pagination } from '../../../../common/pagination'
import { PAGE_SIZE_OPTIONS } from '../../../constant'
import { changeFilter, selectDataFilter } from '../store/slice'

export const PaginationTableDetail = () => {
  const dispatch = useDispatch()

  const { page, pageSize, totalRecords } = useSelector(selectDataFilter)

  const handleSetPage = (value) => {
    dispatch(
      changeFilter({
        page: value,
      }),
    )
  }
  const setPageSize = (value) => {
    dispatch(
      changeFilter({
        pageSize: value,
        page: 1,
      }),
    )
  }

  return (
    <div style={{ paddingTop: 12 }}>
      <Pagination
        page={page}
        pageSize={pageSize}
        total={totalRecords}
        setPage={handleSetPage}
        setPageSize={setPageSize}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
      />
    </div>
  )
}
